import type {
  DailyStatisticDto,
  DailyStatisticsDto,
  MainPageSeoDto,
} from '@features/home/api/home.dto'
import type { DailyStatistic, MainPageSeo } from '@features/home/types'

/** Преобразует backend DTO статистики в доменную модель. */
export const mapDailyStatisticDto = (
  dto: DailyStatisticDto,
): DailyStatistic => ({
  value: dto.value,
  splitValue: dto.splitted_value,
  unit: dto.unit,
  title: dto.title,
})

/** Преобразует backend-ответ статистики в список доменных моделей. */
export const mapDailyStatisticsDto = (
  dto: DailyStatisticsDto,
): DailyStatistic[] => (dto.statistics ?? []).map(mapDailyStatisticDto)

/** Преобразует backend DTO SEO главной страницы в доменную модель. */
export const mapMainPageSeoDto = (dto: MainPageSeoDto): MainPageSeo => ({
  title: dto.title,
  keywords: dto.keywords,
  description: dto.description,
})
